export interface OperationExportDataProps {
  show: boolean;
  icon?: string;
  text?: string;
  onClick: () => void;
  className?: string;
  disabled?: boolean;
}

// Función para exportar el contenido de la tabla visible
export const exportTableToCSV = (tableId: string, filename: string) => {
  const table = document.getElementById(tableId);
  if (!table) return;

  const rows = Array.from(table.querySelectorAll("tr"));
  const csv: string[] = [];

  rows.forEach((row) => {
    const cols = Array.from(row.querySelectorAll("th, td"));
    const rowData = cols.map((col) => {
      // Tomamos el texto visible del elemento
      let text = col.textContent?.trim() || "";
      // Escapar comillas y separar por coma
      if (text.includes(",") || text.includes('"')) {
        text = `"${text.replace(/"/g, '""')}"`;
      }
      return text;
    });
    csv.push(rowData.join(","));
  });

  // Crear y descargar el CSV
  const csvContent = "data:text/csv;charset=utf-8," + csv.join("\n");
  const link = document.createElement("a");
  link.setAttribute("href", encodeURI(csvContent));
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
